import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  Input, Output, EventEmitter
} from '@angular/core';

import {
  ActivatedRoute,
  Router
}                          from '@angular/router';

import {Logger}            from '@/util/logger';
import {ActionService}     from "@/services/action.service";
import {IProjectRow}       from "@/screens/administration/i.project.row";
import {ProjectService}    from "@/services/project.service";
import {first} from "rxjs/operators";
import {Event} from "@/components/krpano/events/event";

@Component({
  standalone: false,
  selector:    'project-list-component',
  template: `<div class="project-list-wrapper" [class.mini]="mini" >

    <ul>
      <li *ngFor="let project of projects">

        <!-- project logo -->

        <span class="project-list-row-cell logo-cell" [class.mini]="mini" >

          <a class="project-list-row-link" routerLink="/project/{{project.key}}">
            <img src="{{project.logo_url ? project.logo_url : '/assets/images/default-project-logo.png'}}" referrerpolicy="no-referrer">
          </a>

        </span>

        <!-- project key -->

        <span class="project-list-row-cell"  [class.mini]="mini" >
          <span style="display: inline-block; margin-left: 12px; margin-right: 12px; ">
            <a class="project-list-row-link" style="color: black; width: 90px" routerLink="/project/{{project.key}}">{{project.key}}</a>
          </span>
        </span>

        <!-- project's org, its name,  description -->

        <span class="project-list-row-cell"  [class.mini]="mini" >

          <span style="font-size: 11px; font-weight: normal; color: grey;">
            <a class="project-list-row-link" routerLink="/organization/{{project.organization.key}}"><b>{{project.organization.key}}</b> - {{project.organization.name}}</a>
          </span>

          <span class="project-list-name">
            <a class="project-list-row-link project-list-name" routerLink="/project/{{project.key}}"><b>{{project.name}}</b></a>
          </span>

          <span style="font-size: 11px; font-weight: normal; color: grey;">
            <i>{{project.description}}</i>
          </span>

        </span>

        <!-- subdivisions -->

        <span class="project-list-row-cell" [class.mini]="mini" style="padding-left: 24px;">

         <span class="project-list-row-subdivision" *ngFor="let sub of project.subdivisions">{{sub.name}}

        </span>

        <span class="project-list-row-cell delete-project-action" (click)="deleteProject(project.id)" [class.mini]="mini" *ngIf="editable && project.deletable" style="padding-left: 24px;">

          <img width="16" src="/assets/images/delete-64.png">

        </span>

      </span>
    </ul>


  </div>`
})

/**
 *
 * @class ProjectListComponent
 *
 * render a list of the given projects via @input
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2022
 *
 */
export class ProjectListComponent implements OnInit, OnDestroy, AfterViewInit {

  /** format as smaller/widget style list */
  @Input() mini: boolean           = false;

  /** can we edit the projects? */
  @Input() editable: boolean       = false;

  /** the set of projects being rendered */
  @Input() projects: IProjectRow[] = [];

  /** output a deletion event so the parent component knows a project was removed */
  @Output() projectDeleted: EventEmitter<IProjectRow> = new EventEmitter<IProjectRow>();

  /**
   * standard constructor
   *
   * @param router     in case we need to redirect the pageuserser
   * @param actions    the GUI actions we can invoke
   * @param route      the active URL
   * @param prjservice for working with projects
   */
  constructor(
    private router:     Router,
    private actions:    ActionService,
    private route:      ActivatedRoute,
    private prjservice: ProjectService
  ) {

  }

  /** delete a project (only when there are no members in the project */
  deleteProject(pid: number) {

    let pl: ProjectListComponent = this;
    let prj: IProjectRow = pl.projects.find(x => x.id == pid);

    Logger.debug(`[ProjectListComponent] deleting project`, prj);

    pl.prjservice.deleteProject(pid)
      .pipe(first())
      .subscribe({

        next: (data: any) => {

          Logger.debug(`[OrganizationDetailsComponent] deleted project: `, data);

          /* update the local project list */

          pl.projects = pl.projects.filter(x => x.id != pid);

          pl.projectDeleted.emit(prj);
        },

        error: (error) => {

          Logger.error(`[ProjectListComponent] could not delete project: `, error);

        }

      });

  }

  /** on creation subscribe to the alert service so we get updates when alerts happen from anywhere */
  ngOnInit() {

    let pl: ProjectListComponent = this;

    Logger.debug('[ProjectListComponent] init...');



  }

  ngAfterViewInit() {


  }

  /* clean up at the end */
  ngOnDestroy() {

  }
}
